import styled from 'styled-components';

type StyledButtonProps = {
  outlined?: boolean;
  fullWidth?: boolean;
};

export const StyledButton = styled.button<StyledButtonProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;

  width: ${({ fullWidth }) => (fullWidth ? '100%' : 'auto')};
  padding: 10px;
  border-radius: 4px;
  border: 1px solid #262ba6;
  background-color: ${({ outlined }) => (outlined ? 'transparent' : '#262BA6')};
  color: ${({ outlined }) => (outlined ? '#262BA6' : '#fff')};
  cursor: pointer;

  font-size: 16px;
  font-weight: 400;
  line-height: 19px;
  letter-spacing: 0em;
  text-align: left;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
